import React from 'react';
import Footer from "./Footer";

const Support = () => {
    return (
        <div className="container">
            <h1 className="page-header">Support the Project</h1>
            <div className="row">
                <div className="col-md-8 col-xs-12">
                    <h3>Online Gift</h3>
                    <p>To support The Charles Brockden Brown Electronic Archive and Scholarly Edition, you can make a tax-deductible contribution today by completing a simple online form.</p>
                    <br />
                    <a className="shinybutton" href="https://www.ucffoundation.org/givetocah?fid=gaB0WOf%2bt84%3d&fdesc=HqZmYEJw%2fw2ASOss309I6rMw1z%2fTgFDb">Donate Online</a>
                    <p style={{ fontSize: "110%", marginTop: "1.75em" }}><em>This form is securely hosted by UCF Foundation, Inc.</em></p>

                    <h3>Give By Mail</h3>
                    <p>If you prefer to donate by mail, you can send a check made payable to “UCF Foundation, Inc.” with “Humanities Center” in the memo line to the address to the right.</p>

                    <h3>Corporate Matching Gifts</h3>
                    <p>Many employers sponsor matching gift programs and will match the charitable contributions made by their employees. Rules vary by company, but many will double or triple employee gifts and some will match gifts by retirees or spouses. To initiate a matching gift, you may call your human resources office for forms.</p>
                </div>
                <div className="col-md-4 col-xs-12">
                    <h2>Contact</h2>
                    <p style={{ fontStyle: "italic" }}>To support the project:</p>
                    <a href="https://cah.ucf.edu/alumni-giving/" target="_blank" rel="noopener noreferrer">UCF College of Arts and Humanities Alumni Giving</a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Support;
